import styled from 'styled-components';
import { CarGalleryStyled } from '../CarGalleryStyled';
import { rem } from 'polished';

export const CarGalleryStyledDS = styled(CarGalleryStyled)`
    .react-multi-carousel {
        &-list {
        }

        &-dot-list {
            margin-bottom: ${rem(20)};
        }

        &-dot {
            button {
                border: none;
                outline: 1px solid ${({ theme }) => theme.colors.black1};
                outline-offset: 2px;
                margin: 0 ${rem(10)};
                background-color: transparent;
                width: ${rem(10)};
                height: ${rem(10)};
                transform: rotate(45deg);
                border-radius: 0;
            }
        }

        &-dot--active {
            button {
                background-color: ${({ theme }) => theme.colors.black1};
            }
        }
    }
    .button-wrapper {
        button.active {
            color: ${({ theme }) => theme.colors.black3};
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
        }
    }
`;
